import { Trash2 } from "lucide-react";
import { FC, MouseEvent, useCallback, useRef, useState } from "react";

import LoadingSpinner from "@/components/loading-spinner/loading-spinner";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { useToast } from "@/components/ui/use-toast";
import * as m from "@/paraglide/messages";
import { cancelOrder } from "@/services/controllers/orders";

const CancelModal: FC<{ orderId: number }> = ({ orderId }) => {
  const { toast } = useToast();
  const confirmRef = useRef<HTMLButtonElement>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [called, setCalled] = useState<boolean>(false);

  const onClick = useCallback(
    (event: MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (!called) event.preventDefault();
      else return;

      setLoading(true);
      cancelOrder({
        params: {
          order_id: orderId,
        },
      })
        .then(() => {
          const cancelOrderEvent = new CustomEvent("cancelOrder", {
            detail: {
              orderId,
            },
          });
          window.dispatchEvent(cancelOrderEvent);
          toast({
            title: m.order_status(),
            description: m.hour_fair_lamb_buy(),
            variant: "success",
            duration: 2000,
          });
        })
        .finally(() => {
          setLoading(false);
          setCalled(true);
          setTimeout(() => {
            confirmRef.current?.click();
          }, 400);
        });
    },
    [called, orderId, toast],
  );

  return (
    <AlertDialog>
      <AlertDialogTrigger className="ps-4">
        <Trash2 className="w-5" />
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{m.petty_fluffy_meerkat_slide()}</AlertDialogTitle>
          <AlertDialogDescription>
            {m.basic_east_mongoose_nudge()}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{m.cancel()}</AlertDialogCancel>
          <AlertDialogAction ref={confirmRef} onClick={onClick as any}>
            {loading ? <LoadingSpinner /> : m.im_sure()}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default CancelModal;
